import { gql } from "@uplift-ltd/apollo";

export const RESOURCE_FRAGMENT = gql`
  fragment ResourceInfo on BundleResource {
    id
    title
    uri
  }
`;
